// REACT & REDUX
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Router, Route, Redirect, Switch, withRouter } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory'

// STYLE, PROPS & TRANSLATIONS
import PropTypes from 'prop-types';
import 'careconnect-ui/lib/css/global.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'react-table/react-table.css'
// import 'primereact/components/common/common.css';
import '@fortawesome/fontawesome-free';

// COMMON

// COMPONENTS

// CONTAINERS
import Root from './components/root/Root.container';
import Login from './components/login/Login.container';
import Home from './components/home/Home.container';



// ACTIONS & API

// *************************************************************************************************************************************

const RedirectToHome = () => <Redirect to="/" />;

class App extends Component {

  renderLogin = () => {
    return (
      <div>
        <div>
          <main>
            <Login />
          </main>
        </div>
      </div>
    );
  }

  renderMain = () => {
    //const history = createBrowserHistory();

    return (
      <Fragment>
        <Switch>
          <Root>
            <Route exact path={""} component={Home} />
          </Root>
        </Switch>
      </Fragment>
    );
  }

  render() {

    return this.renderMain();
  }
}

const mapStateToProps = state => ({
});

export default withRouter(connect(mapStateToProps, null)(App));